import { NwButton } from "@nawy/ui";
import FiltersIcon from "@/modules/common/components/ui-kit/icons/filters-icon";
import FilterChip from "@/modules/common/components/ui-kit/inputs/filter-chip";
import MobileModal from "@/modules/common/components/ui-kit/modals/mobile-modal";
import { ActivityType } from "@/modules/lead-page/dtos/index-v2";
import { useActivityContext } from "@/modules/lead-page/new/hooks/activity-context.hook";
import useFilterMenuItems from "@/modules/lead-page/new/hooks/filter-menu-items.hook";
import {
  FormControlLabel,
  Stack,
  Switch,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";

const MobileFilterMenu = () => {
  const theme = useTheme();

  const [modalOpen, setModalOpen] = useState(false);

  const { logsFilters, updatesFilters, getSelectedLogsFilterText } =
    useFilterMenuItems();

  const { filters, forceRefetch } = useActivityContext();

  // Helper function to get the button text based on selected filters
  const getButtonText = () => {
    const logsText = getSelectedLogsFilterText();

    // If we have child updates and it's enabled, show both
    if (updatesFilters.length > 0 && filters && filters.includeChildLead) {
      return `${logsText} + Child updates`;
    }

    // If only logs filter is different from "All logs", show it
    if (logsText !== "All updates") {
      return logsText;
    }

    // Default to "All Filters" if everything is in default state
    return "All Filters";
  };

  const handleModalConfirmation = () => {
    forceRefetch();
    setModalOpen(false);
  };

  const clearFilters = () => {
    filters?.setIncludeChildLead?.(false);
    filters?.setType?.([
      ActivityType.Comment,
      ActivityType.StatusUpdate,
      ActivityType.AssignmentUpdate,
      ActivityType.Rating,
    ]);

    forceRefetch();
    setModalOpen(false);
  };

  return (
    <>
      <NwButton
        variant="tonal"
        sx={{
          width: "fit-content",
        }}
        onClick={() => setModalOpen(true)}
      >
        <FiltersIcon />
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.md.regular,
            color: theme.nawy.colors.semantic.text.accent,
          }}
        >
          {getButtonText()}
        </Typography>
      </NwButton>

      <MobileModal
        open={modalOpen}
        title="Filter activity"
        confirmButtonText="Apply filters"
        cancelButtonText="Clear filters"
        onConfirm={handleModalConfirmation}
        onClose={() => setModalOpen(false)}
        onCancel={clearFilters}
      >
        <Stack
          direction="column"
          gap={theme.nawy.spacing.md}
          padding={theme.nawy.spacing.md}
        >
          <Stack direction="row" flexWrap="wrap" gap={theme.nawy.spacing.sm}>
            {logsFilters.map((filter) => (
              <FilterChip
                key={filter.label}
                label={filter.label}
                onClick={filter.action}
                checked={filter.checked ?? false}
              />
            ))}
          </Stack>

          <Stack direction="column">
            {updatesFilters.map((filter) => (
              <FormControlLabel
                key={filter.label}
                control={<Switch checked={filter.checked} />}
                sx={{
                  ...theme.nawy.typography.english.variants.body.md.regular,
                }}
                onClick={filter.action}
                label={filter.label}
              />
            ))}
          </Stack>
        </Stack>
      </MobileModal>
    </>
  );
};

export default MobileFilterMenu;
